import React, { useState } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { sendAnalytics } from "../../../action/homeAction";
import { cancelRestaurantReservationV2 } from "../../../action/resReservationV2";


const DailyProgramAckPopupV2 = (props) => {

    const { t } = props

    return (
        <>
            <section class="overlay">
                <div class="overlay-window-container">
                    <div class="overlay-window">
                        <div class="overlay-content padding-0">
                            <div class="overlay-header">
                                <div class="overlay-header-title">
                                    <h2 style={{ color: "#000 !important" }}>{t('resReservationV2.dailyProgramAck.heading1')}</h2>
                                    <p>{props.askDailyProgramAckMsg}</p>
                                    <p>{t('resReservationV2.dailyProgramAck.program_ack_question')}</p>
                                </div>
                                <div class="overlay-header-icon">
                                    <i class="fas fa-calendar"></i>
                                </div>
                            </div>
                        </div>
                        <div class="overlay-controls">
                            <button onClick={() => props.proceed()} class="button">{t('resReservationV2.proceed')}</button>
                            <button onClick={() => props.close()} class="button secondary">{t('resReservationV2.close')}</button>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}


const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
    }
}

export default connect(mapStateToProps, { sendAnalytics })(withTranslation('translations')(DailyProgramAckPopupV2));